import { lsget } from './misc'

export const getHeaders = (): Headers | undefined => {
  const token = lsget('token')
  const user = lsget('user')
  if (!token) {
    localStorage.clear()
    return
  }
  const headers = new Headers()
  headers.append('Access-key', token)

  return headers
}
